import Route from '@ember/routing/route';
import { service } from '@ember/service';
import ContactsCache from 'donor-elf-web/services/contacts-cache';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';

export interface ContactGroupByPropertyRouteModel {
  propertyLabel: string;
  filterPropertyName: string;
  filterOperation: 'any' | '=';
  contactsColumnPropertyName: string;
  valueInfos: { val: string; filterVal: any; count: number }[];
}

export default class ContactByPropertyPropertyRoute extends Route {
  @service declare contactsCache: ContactsCache;
  @service declare navbarSettings: NavbarSettingsService;

  model(params: { label: string }): ContactGroupByPropertyRouteModel {
    if (params.label === 'groups') {
      params.label = 'Groups';
    }

    let model = {
      propertyLabel: params.label,
      filterPropertyName: `contact_custom_${params.label}`,
      filterOperation: 'any',
      contactsColumnPropertyName: params.label,
      valueInfos: [],
    } as ContactGroupByPropertyRouteModel;

    this.navbarSettings.title = `Group by ${model.propertyLabel}`;

    if (model.propertyLabel === 'Groups') {
      model.filterPropertyName = 'contactGroups';
      model.contactsColumnPropertyName = 'groups';
      for (let group of this.contactsCache.sortedGroups) {
        model.valueInfos.push({
          val: group,
          filterVal: group,
          count: this.contactsCache.contacts.filter((x) =>
            x.groups?.includes(group),
          ).length,
        });
      }
    } else {
      let customProperty =
        this.contactsCache.customPropertiesByLowecaseLabel[
          model.propertyLabel.toLowerCase()
        ];
      if (customProperty!.t === 'l') {
        for (let option of customProperty!.o!) {
          model.valueInfos.push({
            val: option,
            filterVal: option,
            count: this.contactsCache.contacts.filter(
              (x) =>
                x.customPropertiesByLabel[model.propertyLabel]?.v[option] ===
                true,
            ).length,
          });
        }
      } else if (customProperty!.t === 'b') {
        model.filterOperation = '=';
        model.valueInfos = [
          {
            val: 'Yes',
            filterVal: true,
            count: this.contactsCache.contacts.filter(
              (x) => x.customPropertiesByLabel[model.propertyLabel]?.v === true,
            ).length,
          },
          {
            val: 'No',
            filterVal: false,
            count: this.contactsCache.contacts.filter(
              (x) =>
                x.customPropertiesByLabel[model.propertyLabel]?.v === false,
            ).length,
          },
        ];
      }
    }

    return model;
  }
}
